import {ReactNode} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuthStateManager} from './hooks/useAuthStateManager';
import {toast} from 'react-toastify';
import {RoutePaths} from './RoutePaths';

const GlobalFunctionWrapper = ({children}: {children: ReactNode}) => {
    const {state} = useLocation();

    const {onAuthenticated, redirectOnAuthenticated} = useAuthStateManager();
    const navigate = useNavigate();

    window.onSocialAuthLogin = socialAuthResult => {
        if (socialAuthResult.authError) {
            if (socialAuthResult.authError.error === 'invalid_grant') {
                /*
                 * on error - if error = "invalid_grant" redirect to complete social registration
                 * */

                const {provider, token, lastName, firstName, email} =
                    socialAuthResult;

                navigate(RoutePaths.accounts.userRegistrationSocial(), {
                    state: {
                        provider,
                        token,
                        lastName,
                        firstName,
                        email
                    }
                });

                return;
            }

            console.error(socialAuthResult.authError);
            toast.error('Unable to complete login or registration.');

            return;
        }

        if (socialAuthResult.authTokens) {
            onAuthenticated(socialAuthResult.authTokens);
            redirectOnAuthenticated((state as {redir?: string | null})?.redir);
            return;
        }

        console.error(socialAuthResult);
        toast.error('Unable to complete login or registration.');
    };

    return <>{children}</>;
};

export default GlobalFunctionWrapper;
